import { connect } from 'react-redux';
import ComparisonFilter from './comparison-filter';
import {
  setComparisonDateRange,
  removeComparisonDateRange,
} from '../../../../reducers/filter.reducers';
import {
  removeReportData,
} from '../../../../reducers/reports.reducers';

const mapStateToProps = (state, ownProps) => {
  const { comparisonDateRanges, comparisonOptions } = state.filter;
  const { comparisonId } = ownProps;

  const comparisonDateRange = comparisonDateRanges.find(cdr => cdr.comparisonId === comparisonId);
  const comparisonOption = comparisonDateRange ? comparisonOptions.find(co => co.name === comparisonDateRange.option) : null;

  return {
    dateRange: state.filter.dateRange,
    comparisonDateRanges: state.filter.comparisonDateRanges,
    locations: state.reports.locations,
    selectedReport: state.reports.selectedReport,
    comparisonDateRange,
    comparisonOptions,
    comparisonOption,
  };
};

const mapDispatchToProps = dispatch => ({
  setComparisonDateRange: startAndEndDate => dispatch(setComparisonDateRange(startAndEndDate)),
  removeComparisonDateRange: comparisonId => dispatch(removeComparisonDateRange(comparisonId)),
  removeReportData: comparisonId => dispatch(removeReportData(comparisonId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonFilter);
